import { Pipe, PipeTransform } from '@angular/core';
import { enumPaymentMethod } from '../utils/enum-payment-method';

@Pipe({
  name: 'isAdvance',
})
export class IsAdvancePipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): boolean {
    if (
      [
        enumPaymentMethod.BANK_TRANSFER_ADV,
        enumPaymentMethod.CASH_ADV,
        enumPaymentMethod.STRIPE_ADVANCE,
      ].includes(value as enumPaymentMethod)
    ) {
      return true;
    }
    return false;
  }
}
//   transform(value: string, ...args: unknown[]): string {
//     if (
//       [
//         enumPaymentMethod.BANK_TRANSFER_ADV,
//         enumPaymentMethod.CASH_ADV,
//         enumPaymentMethod.STRIPE_ADVANCE,
//       ].includes(value as enumPaymentMethod)
//     ) {
//       return 'Acconto';
//     }
//     return 'Saldo';
//   }
// }
